/**
 * Raised when a one-shipper token's user has no active profile
 * on the token's carrier.
 */
export class ForbiddenCarrierProfileError extends Error {
  constructor() {
    super('You do not have permission to perform this action.')
    this.name = 'ForbiddenCarrierProfileError'
  }
}
